import Vue from 'vue'
import VueRouter from 'vue-router'
import SongList from "../views/SongList.vue";
import DuanJuList from "../views/DuanJuList.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/list'
    },
    {
        path: '/song',
        name: 'SongList',
        component: SongList
    },
    {
        path: '/dj',
        name: 'DuanJuList',
        component: DuanJuList
    },
    {
        path: '*',
        name: 'NotFound',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: NotFound,
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
